const particleParams = {
	particles: {
      number: {
        value: 30,
        density: {
          enable: true,
          value_area: 800
        }
      },
      color: {
        value: '#000'
      },
      shape: {
        type: 'circle',
        stroke: {
          width: 0,
          color: '#000'
        },
        polygon: {
          nb_sides: 3
        },
        image: {
          src: '',
          width: 100,
          height: 100
        }
      },
      opacity: {
        value: 0.2,
        random: false,
        anim: {
          enable: false,
          speed: 2,
          opacity_min: 0,
          sync: false
        }
      },
      size: {
        value: 2,
        random: false,
        anim: {
          enable: false,
          speed: 10,
          size_min: 0,
          sync: false
        }
      },
      line_linked: {
        enable: true,
        distance: 150,
        color: '#aaa',
        opacity: 1,
        width: 1
      },
      move: {
        enable: true,
        speed: 2.5,
        direction: 'none',
        random: false,
        straight: false,
        out_mode: 'out',
        bounce: false,
        attract: {
          enable: false,
          rotateX: 3000,
          rotateY: 3000
        }
      },
      array: []
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: {
          enable: true,
          mode: 'repulse'
        },
        onclick: {
          enable: false,
          mode: 'push'
        },
        resize: true
      },
      modes: {
        grab:{
          distance: 100,
          line_linked:{
            opacity: 1
          }
        },
        bubble:{
          distance: 200,
          size: 80,
          duration: 0.4
        },
        repulse:{
          distance: 50,
          duration: 0.4
        },
        push:{
          particles_nb: 4
        },
        remove:{
          particles_nb: 2
        }
      },
      mouse:{}
    },
    retina_detect: true,
    fn: {
      interact: {},
      modes: {},
      vendors:{}
    },
    tmp: {}
};

export default particleParams;


// WEBPACK FOOTER //
// ./src/components/ParticleParams.js